import React, { useState } from 'react';

export default function NcbDebug() {
  const [log, setLog] = useState([]);

  const push = (m) => setLog(prev => [...prev, `[${new Date().toLocaleTimeString()}] ${m}`]);

  const ping = async () => {
    const r = await fetch('/api/_ncb/ping');
    push(`PING ${r.status} ${await r.text()}`);
  };

  const read = async () => {
    const r = await fetch('/api/_ncb/query', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({
        action: 'read',
        table: 'prompt_templates_e4y8n3q5',
        filters: [],
        limit: 3
      })
    });
    push(`READ ${r.status} ${await r.text()}`);
  };

  const create = async () => {
    const r = await fetch('/api/_ncb/query', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({
        action: 'create',
        table: 'prompt_templates_e4y8n3q5',
        values: { user_id: 'anonymous', name: 'Greta test', encrypted_prompt: 'hello' }
      })
    });
    push(`CREATE ${r.status} ${await r.text()}`);
  };

  return (
    <div style={{padding:16}}>
      <h1>NCB Debug</h1>
      <button onClick={ping}>Ping</button>{' '}
      <button onClick={read}>Read</button>{' '}
      <button onClick={create}>Create</button>
      <pre style={{whiteSpace:'pre-wrap', marginTop:12}}>{log.join('\n')}</pre>
    </div>
  );
}